import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StateService {
  static languageState = new Subject<any>();
  constructor(
    ) {
  }
  static changeLanguage(language: any) {
    this.languageState.next(language);
  }
  static getLanguageState(): Observable<any> {
    return this.languageState.asObservable();
  }
}
